import { render, staticRenderFns } from "./assetsReturn.vue?vue&type=template&id=061fe017&"
import script from "./assetsReturn.vue?vue&type=script&lang=js&"
export * from "./assetsReturn.vue?vue&type=script&lang=js&"
import style0 from "./assetsReturn.vue?vue&type=style&index=0&id=061fe017&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports